module.exports = __webpack_public_path__ + "static/media/white-logo-text.75c3207d.png";